import echarts from "echarts";
import React, { useEffect, useRef } from "react";
import _ from "lodash";
import "echarts/extension/bmap/bmap";
require("echarts-wordcloud");

const HCharts: React.FC<{ option: object; style: object }> = ({
  option,
  style,
}) => {
  const wrapper = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (wrapper && wrapper.current) {
      const Div = wrapper.current;
      const myEcharts = echarts.init(Div, "config");
      myEcharts.setOption(option);
      myEcharts.dispatchAction({
        type: "highlight",
        seriesIndex: 0,
        dataIndex: 0,
      });
      const resizeListener = _.throttle(() => {
        console.log("resize");
        myEcharts.resize();
      }, 500);
      window.addEventListener("resize", resizeListener);

      return function clearEchartsAndListener() {
        console.log("clear");
        myEcharts.clear();
        window.removeEventListener("resize", resizeListener);
      };
    }
  }, [option]);

  return <div ref={wrapper} style={style} />;
};

export default HCharts;
